var map = {
	"./Galds.svg": 889,
	"./Kajas.svg": 415,
	"./Kijas.svg": 305,
	"./bernu-galds.jpg": 764,
	"./galds-kijas.jpg": 379,
	"./galds.jpg": 206,
	"./kajas.jpg": 586,
	"./kastes.jpg": 621,
	"./kijas-double.jpg": 376,
	"./kijas-new.jpg": 42,
	"./ripas-kaulini.jpg": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;